// test2652
(2652 && 0);
